<template>
  <div class="bookSetting">
    <el-form
      ref="addForm"
      :model="applyDate"
      :rules="rules"
      label-width="100px"
      label-position="left"
      style="margin-top:24px"
    >
      <el-form-item prop="bookurl" label="封面">
        <el-upload
          class="uploader fl book-uploader"
          :action="uploadurl"
          :headers="headers"
          :on-success="handlebookSuccess"
          :before-upload="beforebookUpload"
        >
          <img
            v-if="bookUrl"
            :src="bookUrl"
            class="bookUrl"
            width="150px"
            height="150px"
          />
          <img
            src="~img/default.png"
            v-else
            class="el-icon-plus avatar-uploader-icon"
          />
        </el-upload>
        <div class="uploadhint">
          <p>
            上传作品封面
          </p>
          400*560像素<br />
          小于1M<br />
          格式为jpg,png,gif
        </div>
      </el-form-item>
      <el-form-item prop="name" label="名称">
        <el-input
          v-model="applyDate.name"
          placeholder="作品名称"
          maxlength="20"
          minlength="1"
          show-word-limit
          class="login-form-input"
          ref="name"
        ></el-input>
      </el-form-item>
      <el-form-item prop="sort" label="分类">
        <el-select
          size="small"
          class="select"
          v-model="applyDate.sort"
          placeholder="分类"
        >
          <el-option
            v-for="item in sortlist"
            :key="item.code"
            :label="item.desc"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <el-select
          size="small"
          class="select"
          v-model="applyDate.publication"
          placeholder="请选择"
        >
          <el-option
            v-for="item in publicationList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          size="small"
          class="select"
          v-model="applyDate.first"
          placeholder="请选择"
        >
          <el-option
            v-for="item in firstList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="introduce" label="内容简介">
        <el-input
          v-model="applyDate.introduce"
          type="textarea"
          minlength="30"
          maxlength="1000"
          show-word-limit
          ref="introduce"
        ></el-input>
        <p
          class="hint"
          style="margin-bottom:0px;line-height:16px;text-align:left;margin-top:10px;color:#888"
        >
          请勿填写与作品无关的信息
        </p>
      </el-form-item>
      <el-form-item prop="extendRecommend" label="互动信息">
        <el-input
          v-model="applyDate.extendRecommend"
          type="textarea"
          maxlength="1000"
          show-word-limit
          ref="extendRecommend"
        ></el-input>
      </el-form-item>
      <div class="clearfix tagwrap">
        <label class="fl">标签</label>
        <div class="tagbox fl">
          <div class="chooseTag clearfix" @click="choosetag">
            <ul class="choosed fl">
              <li v-for="(tag, index) in choosetags" :key="tag" class="fl">
                <a href="javaScript:">{{ tag }}</a>
                <span @click="deltag(index)" title="删除" class="rm"></span>
              </li>
            </ul>
            <input
              type="text"
              ref="cus"
              maxlength="2"
              v-model="tagvalue"
              @focus="custom"
              @keydown.enter="custom"
              class="custom fl"
              autofocus="autofocus"
            />
          </div>
          <ul class="clearfix alltags">
            <li
              :class="{ fl: true, choosedactive: choosedactive }"
              v-for="item in taglists"
              :key="item"
              @click="chooseyourstag(item)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <p
        class="hint"
        style="margin-bottom:15px;line-height:16px;text-align:left;margin-top:10px;color:#888;margin-left:100px"
      >
        选择列表中的标签(最多5个)
      </p>
      <el-form-item>
        <el-button
          v-if="isnewBook"
          class="usersub aubtn"
          size="medium"
          @click="submitapply('addForm')"
          >创建作品</el-button
        >
        <el-button
          v-else
          class="usersub aubtn"
          size="medium"
          @click="savebookInfo('addForm')"
          >保存修改</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { WRITE } from "apiurl/index.js";
import {
  sortList,
  addbook,
  getbookinfo,
  editbook,
  tagslist
} from "apiurl/author";
import { getToken, setAbookid } from "utils/storage";
import { mapState } from "vuex";
export default {
  data() {
    return {
      applyDate: {
        name: "",
        extendRecommend: "",
        first: true,
        iconTempFile: "",
        introduce: "",
        publication: false,
        sort: "",
        tags: ""
      },
      isListShow: false,
      rules: {
        name: [{ required: true, message: "请输入作品名称", trigger: "blur" }],
        introduce: [
          { required: true, message: "请输入简介内容", trigger: "blur" }
        ],
        sort: [{ required: true, message: "请选择分类", trigger: "change" }]
      },
      checked: true,
      bookUrl: "",
      rollList: [],
      rollvalue: "",
      tagvalue: "", //自定义tags的值
      uploadurl: "", // 上传地址
      taglists: [],
      headers: {
        Authorization: "Bearer " + getToken()
      },
      choosedactive: false,
      choosetags: [],
      firstList: [
        { value: true, label: "首发" },
        { value: false, label: "非首发" }
      ], //首发
      publicationList: [
        { value: false, label: "未出版" },
        { value: true, label: "已出版" }
      ], //是否出版
      sortlist: [], //分类列表
      isnewBook: true, //按钮请求
      editbook: []
    };
  },
  methods: {
    // 上传图片成功后
    handlebookSuccess(res, file, fileList) {
      if (res.success) {
        this.bookUrl = res.data;
        this.applyDate.iconTempFile = res.data;
        if (fileList.length > 1) {
          fileList = fileList.splice(0, fileList.length - 1);
        }
      }
    },
    // 上传图片之前
    beforebookUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt1M;
    },
    choosetag() {
      this.$refs.cus.focus();
    },
    // 挑选你的作品标签
    chooseyourstag(tag) {
      if (this.choosetags.length < 5) {
        this.choosetags.push(tag);
        this.choosetags = Array.from(new Set(this.choosetags));
      }
    },
    // 删除标签
    deltag(index) {
      this.choosetags.splice(index, 1);
    },
    // 提交自定义标签
    custom() {
      if (this.choosetags.length < 5 && this.tagvalue) {
        this.choosetags.push(this.tagvalue);
        this.choosetags = Array.from(new Set(this.choosetags));
        this.tagvalue = "";
      }
    },
    /* 获取分类 */
    async getsortlist() {
      let res = await sortList();
      if (res.success) {
        this.sortlist = res.data;
      }
    },
    // 获取tags
    async gettags() {
      let res = await tagslist();
      if (res.success) {
        this.taglists = res.data.slice(0, 100);
      }
    },
    /* 提交作品 */
    submitapply(form) {
      this.applyDate.tags = this.choosetags.join(",");
      let parmas = this.applyDate;
      //console.log(this.applyDate);
      this.$refs[form].validate(valid => {
        if (valid) {
          let str = this.applyDate.name.replace(/\s*/g, "");
          if (str.length > 0) {
            addbook(parmas)
              .then(res => {
                if (res.success) {
                  this.$message({
                    message: "创建成功",
                    type: "success"
                  });
                  setAbookid(res.data.id);
                  this.$store.dispatch("setAInfo", {
                    bookid: res.data.id,
                    allowPrice: false,
                    name: this.applyDate.name
                  });
                  this.$router.push("/authorManage/newChapter/" + res.data.id);
                }
              })
              .catch(() => {});
          } else {
            this.$message({
              message: "作品标题不能为空",
              type: "error"
            });
          }
        }
      });
    },
    // 保存作品信息
    savebookInfo(form) {
      this.applyDate.tags = this.choosetags.join(",");
      let parmas = this.applyDate;
      this.$refs[form].validate(valid => {
        if (valid) {
          let str = this.applyDate.name.replace(/\s*/g, "");
          if (str.length > 0) {
            editbook(parmas, this.$route.params.id)
              .then(res => {
                if (res.success) {
                  this.$message({
                    message: "保存成功",
                    type: "success"
                  });
                  this.$store.dispatch("setAInfo", {
                    bookid: this.Abookid,
                    allowPrice: false,
                    name: this.applyDate.name
                  });
                }
              })
              .catch(() => {});
          } else {
            this.$message({
              message: "作品标题不能为空",
              type: "error"
            });
          }
        }
      });
    },
    /* 根据作品id获取可编辑信息 */
    async getinfo() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      if (this.$route.params.id !== "0") {
        let res = await getbookinfo(this.$route.params.id);
        this.editbook = res.data;
        let book = res.data;
        this.applyDate = {
          name: book.iname,
          extendRecommend: book.iextendRecommend,
          first: book.ifirst,
          iconTempFile: book.iconUrl,
          introduce: book.iintroduce,
          publication: book.ipublication,
          sort: book.isort,
          tags: book.itags
        };
        this.bookUrl = this.imgURL + this.applyDate.iconTempFile;
        if (this.applyDate.tags != "") {
          this.choosetags = this.applyDate.tags.split(",");
        }
      }
    }
  },
  mounted() {
    // 上传图片地址
    this.uploadurl = `${WRITE}/book/add/icon`;
    /* 获取分类 */
    this.getsortlist();
    /* 根据作品id获取可编辑信息 */
    this.getinfo();
    if (this.$route.params.id > 0) {
      this.isnewBook = false;
    }
    /* 获取tags */
    this.gettags();
  },
  computed: mapState({
    Abookid: state => state.author.bookid
  })
};
</script>

<style>
.bookSetting .el-form {
  padding: 0 388px 0 24px;
}
.bookSetting .el-form-item__content {
  line-height: 0px;
}
.bookSetting .el-form-item__label {
  height: 34px;
  line-height: 34px;
}
.bookSetting .el-input__inner {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
}
.bookSetting .el-form-item__label {
  font-size: 16px;
}
.book-uploader {
  width: 120px;
}
.book-uploader img {
  width: 120px;
  height: 169px;
}
.bookSetting .select .el-input--suffix .el-input__inner {
  height: 34px;
  line-height: 34px;
}
.bookSetting .select {
  margin-right: 24px;
}
.bookSetting .el-textarea__inner {
  height: 150px;
}
.el-textarea .el-input__count {
  display: block;
  padding: 10px 0;
}
</style>
<style lang="stylus" scoped>
.applyStatus
    font-size 14px
    font-weight 500
    color rgba(9, 178, 26, 1)
.InfoWrap
    .normalbox
        margin 24px 75px 24px 24px
.uploadhint
    font-size 12px
    color rgba(136, 136, 136, 1)
    line-height 17px
    position absolute
    bottom 0px
    left 140px
    p
        display block
        height 20px
        font-size 14px
        color #333
        font-weight 600
.hint
    font-size 12px
    color rgba(248, 81, 81, 1)
    margin-bottom 24px
    .book-uploader
        width 150px
        height 150px
        overflow hidden
        margin 0 40px 0 110px
        img
            width 150px
            height 150px
.tagwrap
    label
        width 100px
        display inline-block
        height 36px
        line-height 36px
        color #606266
    .tagbox
        padding 5px 12px 5px 15px
        width 436px
        border 1px solid #DCDFE6
        border-radius 4px
        .chooseTag
            .custom
                width 50px
                height 16px
                border 1px solid #fff
                margin-bottom 10px
                &:focus
                    border 1px solid #48a2df
            .choosed
                li
                    background #48a2df
                    padding 0px 18px 0px 4px
                    height 18px
                    line-height 18px
                    border-radius 3px
                    border 2px solid #48a2df
                    white-space nowrap
                    position relative
                    margin-right 6px
                    a
                        color #fff !important
                        font-size 12px
                    span
                        cursor pointer
                        width 11px
                        height 11px
                        overflow hidden
                        display block
                        position absolute
                        right 4px
                        top 4px
                        background url('~img/author/btn-tag-del.gif') no-repeat
        .alltags
            display block
            li
                padding 3px 5px
                border 1px solid #DCDFE6
                font-size 12px
                cursor pointer
                border-radius 3px
                color #606266
                margin 3px
                &.choosedactive
                    border 1px solid #48a2df
</style>
